import AuthInput from '@/@shared/components/forms/AuthInput';
import SubmitButton from '@/@shared/components/primitives/Button/SubmitButton';
import { useTransAuth } from '@/@shared/hooks/useTranslations';
import { hasAnyNestedError, getNestedErrorMessage } from '@/@shared/utils/formHelpers';
import type { PannelProps } from '@/app/[locale]/(auth)/signup/(funnel)/PannelType';
import styles from '@/app/[locale]/(auth)/signup/(funnel)/RegisterComp.module.scss';
import { clc } from '@/legacy/components/base/utils';
import { errorStyle } from '@/legacy/components/input/inputUtil';
import type { SignUpType } from '@/model/zod/authZod';
import { useFormContext } from 'react-hook-form';

const GetPasswords = ({ locale, onNext }: PannelProps) => {
	const t = useTransAuth('signup.passwordInput');

	const {
		register,
		setValue,
		getValues,
		watch,
		formState: { errors, isSubmitting },
		trigger,
	} = useFormContext<SignUpType>();

	const getPasswordRegister = register('getPasswords.getPassword', {
		required: true,
	});
	const confirmPasswordRegister = register('getPasswords.confirmPassword', {
		required: true,
	});

	// watch를 사용하여 리액티브하게 값 감시 (복붙 대응)
	const passwordValue = watch('getPasswords.getPassword');
	const confirmPasswordValue = watch('getPasswords.confirmPassword');

	// Enter 키로 폼 제출
	const handleEnterPress = async () => {
		const hasErrors = hasAnyNestedError(
			errors,
			['getPasswords', 'getPassword'],
			['getPasswords', 'confirmPassword']
		);
		const isValid = !hasErrors && Boolean(passwordValue) && Boolean(confirmPasswordValue);

		if (isValid && !isSubmitting) {
			// Submit 버튼 클릭 시뮬레이션 (폼 제출)
			const submitButton = document.querySelector<HTMLButtonElement>('button[type="submit"]');
			submitButton?.click();
		}
	};

	return (
		<>
			<div className={clc(styles.title, styles.under20)}>
				<div className={styles.line2}>
					<span>{t('description')}</span>
				</div>
			</div>
			<AuthInput
				className={errorStyle(getNestedErrorMessage(errors, 'getPasswords', 'getPassword'))}
				errors={errors}
				keyName={'getPasswords.getPassword'}
				// label={t('label.getPassword')}

				required
				{...getPasswordRegister}
				getValues={getValues}
				// autoComplete="new-password"
				placeholder={t('passwordPlaceholder')}
				setValue={setValue}
				type="password"
				onEnterPress={handleEnterPress}
			/>
			<br />
			<AuthInput
				className={errorStyle(getNestedErrorMessage(errors, 'getPasswords', 'confirmPassword'))}
				errors={errors}
				keyName={'getPasswords.confirmPassword'}
				// label={t('label.confirmPassword')}

				required
				{...confirmPasswordRegister}
				autoComplete="off"
				// autoComplete="new-password"
				getValues={getValues}
				placeholder={t('confirmPlaceholder')}
				setValue={setValue}
				type="password"
				onEnterPress={handleEnterPress}
			/>
			<div className={styles.submitArea}>
				<SubmitButton
					loading={isSubmitting}
					isValid={
						!hasAnyNestedError(
							errors,
							['getPasswords', 'getPassword'],
							['getPasswords', 'confirmPassword']
						) &&
						Boolean(passwordValue) &&
						Boolean(confirmPasswordValue)
					}
					action={t('submit')}
					loadingText={t('loading')}
					onClick={() => {}}
					type="submit"
					fullWidth
				/>
			</div>
		</>
	);
};

export default GetPasswords;
